import React from "react";
import styles from "./styles";
import Carousel from "simple-react-carousel";

const Galerie = function Galerie(props) {

  console.log("Chargement du composant Galerie");
  
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Galerie</h1>
      <Carousel>
        <img src="/images/antinea/img1.jpg" alt="Image 1" />
        <img src="/images/antinea/img2.jpg" alt="Image 2" />
        <img src="/images/antinea/img3.jpg" alt="Image 3" />
      </Carousel>
    </div>
  );
};

export default Galerie;
